module.exports = __webpack_public_path__ + "static/media/hair (61).242ef5b5.jpg";